import {
  FormControl,
  InputLabel,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { useSearchContext } from "../../../contexts/SearchContext";
import { useCategories } from "../../../hooks/queries/useCategories";
import { FilterSelect } from "./FilterSelect";

const FilterCategory = () => {
  const { searchCategoryGroup, searchCategory, setSearchCategory } =
    useSearchContext();
  const { data: categoriesData = [] } = useCategories();

  const categories = categoriesData
    .filter(category => category.group === searchCategoryGroup)
    .map(category => category.category);

  const onChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value !== "0" ? event.target.value : "*";
    setSearchCategory(value);
  };

  return (
    <FormControl size="small" variant="outlined" fullWidth>
      <InputLabel>Categoria:</InputLabel>
      <FilterSelect
        value={searchCategory}
        onChange={onChange}
        label="Categoria"
      >
        <MenuItem value="*">Todos os níveis</MenuItem>
        {categories.map(category => (
          <MenuItem
            key={category}
            value={category}
            selected={searchCategory === category}
          >
            {category}
          </MenuItem>
        ))}
      </FilterSelect>
    </FormControl>
  );
};

export default FilterCategory;
